<template>
  <div class="grid-content">
    <div class="loading" v-loading="loading">
      <el-form ref="globalPriceSettings" :model="globalPriceSettings" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="接机服务" prop="airportPickUp.Value">
              <el-input :disabled="optionModel.isReadonly" placeholder="请输入价格"
                v-model="globalPriceSettings.airportPickUp.Value" class="input-width">
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <hr>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row v-if="!optionModel.isReadonly" class="cs-filter-row">
      <el-col :span="4" class="footer-left">
        <el-button size="medium" :disabled="submitBtnDisable" :type="submitBtnClass" @click="saveChanges">保存更新
        </el-button>
      </el-col>
      <el-col :span="16" class="footer-right">
        <el-alert :closable="false" v-show="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
  }

  .el-input {
    text-align-last: center;
  }
}
</style>

<script>
import {
  getGlobalPriceSettings,
  saveGlobalPriceSettings
} from "../../service/globalPriceSetting.service";

export default {
  props: {
    isActive: Boolean,
    options: {
      isReadonly: Boolean
    }
  },
  data() {
    let validateValue = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的价格";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      isLoadedData: false,
      loading: false,
      optionModel: {
        isReadonly: false
      },
      globalPriceSettings: {
        airportPickUp: {},
      },
      submitBtnClass: "primary",
      submitBtnDisable: true,
      showError: false,
      errorMessage: "",
      rules: {
        airportPickUp: {
          Value: [
            {
              required: true,
              message: "价格不能为空",
              trigger: "blur"
            },
            {
              validator: validateValue,
              trigger: "blur"
            }
          ]
        },
      }
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadOptionModelFromProps();
    this.loadGlobalPriceSettings();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    loadOptionModelFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.isReadonly = options.isReadonly;
      } else {
        this.optionModel.isReadonly = false;
      }
    },
    checkAllInputs(onlyCheck) {
      let isValid = true;

      let $refGPS = this.$refs["globalPriceSettings"];
      if (!!$refGPS) {
        $refGPS.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (!onlyCheck) {
        this.submitBtnClass = isValid ? "primary" : "info";
        this.submitBtnDisable = !isValid;
      }

      return isValid;
    },
    async loadGlobalPriceSettings() {
      if (!this.isActive) {
        return;
      }
      let gpTypes = [
        this.GLOBAL.globalPriceType.airportPickUpPrice
      ];

      this.loading = true;
      this.isLoadedData = true;
      let result = await getGlobalPriceSettings(gpTypes);
      if (!!result && result.success) {
        this.globalPriceSettings.airportPickUp = this.__findGlobalPriceSettingByType(
          result.data,
          this.GLOBAL.globalPriceType.airportPickUpPrice
        );
      } else {
        this.globalPriceSettings.airportPickUp = this.initGlobalPriceSetting(
          this.GLOBAL.globalPriceType.airportPickUpPrice
        );
      }

      this.loading = false;
    },
    async saveChanges() {
      let isValid = this.checkAllInputs(true);
      if (!isValid) {
        return;
      }

      this.submitBtnDisable = true;

      let showError = false;
      let errorMessage = "";
      let gtSettings = [
        this.globalPriceSettings.airportPickUp,
      ];
      let result = await saveGlobalPriceSettings(gtSettings);
      if (!result || !result.success || !result.data) {
        showError = true;
        errorMessage += result.message;
      }

      this.$message({
        message: `保存更新${!showError ? "成功" : "失败"}`,
        type: !showError ? "success" : "error"
      });
      this.showError = showError;
      this.errorMessage = errorMessage;

      this.submitBtnDisable = false;

      if (!showError) await this.loadGlobalPriceSettings();
    },
    initGlobalPriceSetting(type) {
      let gpSetting = {
        Id: 0,
        Enable: true,
        Type: type,
        Value: 0
      };

      return gpSetting;
    },
    __findGlobalPriceSettingByType(gpSettings, type) {
      let result = null;

      if (!!gpSettings && gpSettings.length > 0)
        for (let i = 0; i < gpSettings.length; i++) {
          let element = gpSettings[i];
          if (element.Type == type) {
            result = element;
            break;
          }
        }

      if (!result) result = this.initGlobalPriceSetting(type);

      return result;
    }
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.loadGlobalPriceSettings();
      }
    },
    options: function (newVal) {
      this.loadOptionModelFromProps(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/airportPickUpPrice.vue